import { Routes } from '@angular/router';
import { SOFTLINE_PERMISSION_GESAMTABFRAGE } from './gesamtabfrage.permissions';
import { AuthenticationGuard, AuthorizationGuard } from '@softline/auth';
import { BelegartRepository } from './repositories/belegart.repository';
import { BelegartService } from './services/belegart.service';
import { BelegQueryService } from './services/beleg-query.service';
import { BelegRepository } from './repositories/beleg.repository';
import { BelegService } from './services/beleg.service';
import { BusinessCaseService } from './services/business-case.service';
import { BusinessCaseRepository } from './repositories/business-case.repository';

export const gesamtabfrageRoutes: Routes = [
  {
    path: 'gesamtabfrage',
    children: [
      {
        path: '',
        loadComponent: () =>
          import('./pages/gesamtabfrage.component').then(
            (o) => o.GesamtabfrageComponent
          ),
        children: [
          {
            path: ':type/find',
            loadComponent: () =>
              import(
                './pages/gesamtabfrage-query/gesamtabfrage-query.component'
              ).then((o) => o.GesamtabfrageQueryComponent),
          },
          {
            path: ':type/list',
            loadComponent: () =>
              import(
                './pages/gesamtabfrage-list/gesamtabfrage-list.component'
              ).then((o) => o.GesamtabfrageListComponent),
          },
          {
            path: ':type/business-case/:id',
            loadComponent: () =>
              import('./pages/business-case/business-case.component').then(
                (o) => o.BusinessCaseComponent
              ),
            providers: [BusinessCaseRepository]
          },
          {
            path: '',
            loadComponent: () =>
              import('./pages/belegarten/belegarten.component').then(
                (o) => o.BelegartenComponent
              ),
          },
          { path: '**', redirectTo: '' },
        ],
      },
    ],
    canActivate: [AuthenticationGuard, AuthorizationGuard],
    canActivateChild: [AuthenticationGuard, AuthorizationGuard],
    runGuardsAndResolvers: 'pathParamsOrQueryParamsChange',
    data: { permission: SOFTLINE_PERMISSION_GESAMTABFRAGE },
    providers: [
      BelegartRepository,
      BelegartService,
      BelegQueryService,
      BelegRepository,
      BelegService,
    ]
  },
];
